var colors = {
    mediumLightGrey: 'rgb(187, 187, 187)',
    lightGrey: '#DDD',
    grey: '#898989',
    black: 'rgb(0, 0, 0)',
    white: '#fff',
    cyanBlue: '#889db1',
    yellow: 'yellow',
    primary: '#30567b',
    goldenrod: 'rgb(201, 143, 21)',
    navyBlue: 'rgb(36,45,66)',
    darkNavyBlue: 'rgb(6,16,31)',
    lightYellow: 'rgb(19, 24, 62)',
    blueGrey: '#acb0c1',
    blueHeader: '#131927',
    blueSubHeader: '#202B43',
    blue: 'rgb(43, 56, 86)',
};
var defaultTheme = {
    colors: colors,
    line: {
        borderColor: 'white',
    },
    button: {
        border: '1.5px solid',
        color: colors.white,
        borderRadius: '0px',
        backgroundColor: 'inherit',
        outline: 'none',
        boxSizing: 'border-box',
        fontFamily: 'Arial',
        cursor: 'pointer',
        borderColor: {
            left: colors.mediumLightGrey,
            top: colors.mediumLightGrey,
            right: colors.black,
            bottom: colors.black,
        },
        active: {
            borderColor: {
                left: colors.black,
                top: colors.black,
                right: colors.mediumLightGrey,
                bottom: colors.mediumLightGrey,
            },
        },
        focus: {
            outline: 'none',
        },
        hover: {
            backgroundColor: 'inherit',
        },
        toggle: {
            onBackgroundColor: 'inherit',
            offBackgroundColor: 'inherit'
        },
        bgToggle: {
            onBackgroundColor: 'inherit',
            offBackgroundColor: 'inherit'
        },
    },
    checkbox: {
        textAlign: 'left',
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: 'inherit',
        input: {
            minWidth: '0px',
            margin: '0px',
            height: '15px',
            width: '15px',
            appearance: 'auto',
            background: colors.white,
            checked: {
                appearance: 'auto',
                background: colors.blue,
            },
        },
        label: {
            marginLeft: '4px',
            border: 'none',
            alignItems: 'center',
            color: '#EEE756'
        },
    },
    comboBox: {
        color: colors.white,
        background: 'inherit',
        backgroundColor: 'inherit',
        border: '1.5px solid',
        borderRadius: '0 !important',
        borderColor: {
            top: colors.lightGrey,
            left: colors.lightGrey,
            right: colors.black,
            bottom: colors.black,
        },
        outline: 'none',
        dropdownIcon: {
            container: {
                position: 'relative',
            },
            leftTrapeziod: {
                position: 'relative',
                borderLeft: '2px solid red',
                borderTop: '2px solid transparent',
                borderBottom: '2px solid transparent',
                height: '6px',
                width: '0',
            },
            rightTrapezoid: {
                position: 'relative',
                borderRight: '2px solid red',
                borderTop: '2px solid transparent',
                borderBottom: '2px solid transparent',
                height: '6px',
                width: '0',
            },
            bottomTrapezoid: {
                position: 'relative',
                borderBottom: '2px solid red',
                borderLeft: '2px solid transparent',
                borderRight: '2px solid transparent',
                height: '0',
                width: '6px',
            },
            triangle: {
                position: 'relative',
                height: '0',
                width: '0',
                borderTop: '6px solid #000',
                borderBottom: '0',
                borderLeft: '3px solid transparent',
                borderRight: '3px solid transparent',
            },
        },
    },
    dropdown: {
        container: {
            position: 'relative',
        },
        trapezoid: {
            position: 'relative',
            redBorder: '2px solid red',
            transparentBorder: '2px solid transparent',
        },
        triangle: {
            position: 'relative',
            height: '0',
            width: '0',
            blackBorder: '6px solid #000',
            transparentBorder: '3px solid transparent',
        },
    },
    treeWidget: {
        border: "1px solid",
        borderColor: colors.black,
        backgroundColor: colors.navyBlue,
        borderCollapse: 'seperate',
        borderSpacing: '0px',
        display: 'flex',
        flexDirection: 'column',
        color: colors.white,
        header: {
            flex: '0 0 25px',
            paddingLeft: '4px',
            color: colors.yellow,
            border: "1px solid " + colors.black,
            borderLeftColor: colors.lightGrey,
            borderTopColor: colors.lightGrey,
            backgroundColor: colors.blueHeader,
            span: {
                verticalAlign: 'middle',
            },
        },
        ul: {
            height: 'inherit',
            overflow: 'auto',
            listStyleType: 'none',
            marginTop: '2px',
            marginBottom: '2px',
            cursor: 'pointer',
            li: {
                display: 'none',
                marginBottom: '4px',
                selectedBgColor: colors.blueGrey,
                nested: {
                    content: '\\25B6',
                    color: colors.white,
                    display: 'inline-block',
                    marginRight: '6px',
                },
                caratDown: {
                    transform: 'rotate(90deg)',
                },
            },
        },
    },
    dataGrid: {
        minHeight: '180px',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'auto',
        position: 'absolute',
        table: {
            color: colors.yellow,
            borderCollapse: 'seperate',
            borderSpacing: '0px',
            height: 'auto',
            width: '100%',
            border: "1px solid",
            borderColor: colors.black,
            backgroundColor: colors.navyBlue,
            thead: {
                tr: {
                    height: '25px',
                    width: '100%',
                    tableLayout: 'fixed',
                    th: {
                        position: 'sticky',
                        top: '0px',
                        border: "1px solid " + colors.black,
                        borderLeft: colors.lightGrey,
                        borderTop: colors.lightGrey,
                        backgroundColor: colors.blueHeader,
                        fontWeight: 'bold',
                        textAlign: 'left',
                        rowHeader: {
                            textAlign: 'left'
                        }
                    },
                },
            },
            tbody: {
                display: 'block',
                color: colors.white,
                tr: {
                    display: 'block',
                    tableLayout: 'fixed',
                    borderLeft: "1px solid " + colors.mediumLightGrey,
                    height: '20px',
                    width: '100%',
                    th: {
                        float: 'left',
                        color: colors.yellow,
                    },
                    selectedBgColor: colors.white,
                    selectedFontColor: colors.black,
                    td: {
                        float: 'left',
                        border: "1px solid " + colors.mediumLightGrey,
                        borderLeft: '0px',
                        borderTop: '0px',
                        cursor: 'pointer',
                    },
                },
            },
        },
    },
    gridItem: {
        background: 'inherit',
    },
    gridLayout: {
        background: 'inherit',
        display: 'grid',
        gridGap: '10px',
        padding: '10px',
        height: 'inherit',
        width: 'inherit',
        item: {
            position: 'relative',
            display: 'flex',
            background: 'inherit',
            height: 'inherit',
            width: 'inherit',
            marginRight: '1px',
            marginTop: '0.5px',
            marginLeft: '1px',
            marginBottom: '0.5px',
            border: '1px solid',
            borderColor: colors.grey,
            minHeight: '12px',
            textAlign: 'left',
            boxSizing: 'border-box',
            overflow: 'unset',
            content: {
                flex: '1 1 auto',
            },
        },
    },
    gridRow: {
        background: 'inherit',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
    },
    groupBox: {
        border: '1px solid',
        borderColor: {
            left: colors.mediumLightGrey,
            top: colors.mediumLightGrey,
            right: colors.black,
            bottom: colors.black,
        },
        title: {
            color: colors.white,
        },
        fieldset: {
            border: 'none',
        },
    },
    hBoxLayout: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        textAlign: 'center',
        height: 'inherit',
        width: 'auto',
        item: {
            height: 'inherit',
            width: 'auto',
        },
    },
    vBoxLayout: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        textAlign: 'center',
        height: 'inherit',
    },
    label: {
        display: 'inline-flex',
        color: colors.white,
        disabledColor: colors.mediumLightGrey,
        backgroundColor: 'transparent',
        border: 'none',
        borderColor: colors.grey,
        boxSizing: 'border-box !important',
        alignItems: 'left',
        fontSize: '0.9em',
        span: {
            width: '100%',
            whiteSpace: 'pre-line',
        },
        header: {
            alignItems: 'center',
            width: '100%',
            subheaderbgColor: colors.blueSubHeader,
            headerbgColor: colors.blueHeader,
        },
        fontWeight: 'normal',
        paddingLeft: '0px',
        paddingRight: '0px',
    },
    list: {
        boxSizing: 'border-box !important',
        border: '1.5px solid',
        borderColor: {
            left: colors.black,
            top: colors.black,
            right: colors.right,
            bottom: colors.bottom,
        },
        item: {
            width: '100%',
            height: '1.5em',
            position: 'relative',
            value: {
                position: 'absolute',
                top: '0',
            },
        },
    },
    listWidget: {
        boxSizing: 'border-box !important',
        backgroundColor: colors.darkNavyBlue,
        border: '1.5px solid',
        borderColor: {
            left: colors.black,
            top: colors.black,
            right: colors.right,
            bottom: colors.bottom,
        },
        item: {
            color: colors.white,
            width: '100%',
            height: '1.5em',
            position: 'relative',
            value: {
                position: 'absolute',
                top: '0',
            },
        },
    },
    panel: {
        boxSizing: 'border-box !important',
        background: 'inherit',
        raised: {
            border: '1px solid',
            borderColor: {
                left: colors.mediumLightGrey,
                top: colors.mediumLightGrey,
                right: colors.black,
                bottom: colors.black,
            },
        },
        sunken: {
            border: '1px solid',
            borderColor: {
                right: colors.mediumLightGrey,
                bottom: colors.mediumLightGrey,
                left: colors.black,
                top: colors.black,
            },
        },
    },
    window: {
        background: 'white',
        position: 'absolute',
        boxSizing: 'content-box',
        height: 'fit-content',
        width: 'fit-content',
        border: "5px ridge " + colors.mediumLightGrey,
        fontFamily: '"Oxygen Mono",Monaco,monospace',
        fontSize: '12px',
        zIndex: '100',
        div: {
            boxSizing: 'content-box',
        },
        title: {
            position: 'relative',
            height: '20px',
            background: colors.mediumLightGrey,
            color: colors.black,
            border: '2px solid',
            borderColor: {
                left: colors.white,
                top: colors.white,
                right: colors.grey,
                bottom: colors.grey,
            },
            textAlign: 'center',
        },
        content: {
            position: 'relative',
            background: colors.primary,
            div: {
                position: 'relative',
            },
        },
    },
    radio: {
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        input: {
            minWidth: 'auto !important',
            accentColor: 'inherit',
        },
        button: {
            height: '8px',
            width: '8px',
            marginRight: '4px',
            transform: 'rotate(45deg)',
            border: '1.5px solid',
            background: 'inherit',
            cursor: 'pointer',
            borderColor: {
                left: colors.mediumLightGrey,
                top: colors.mediumLightGrey,
                right: colors.black,
                bottom: colors.black,
            },
            checked: {
                background: colors.cyanBlue,
                borderColor: {
                    left: colors.black,
                    top: colors.black,
                    right: colors.mediumLightGrey,
                    bottom: colors.mediumLightGrey,
                },
            },
        },
        label: {
            marginLeft: '4px',
            border: 'none',
            color: '#EEE756'
        },
    },
    textInput: {
        background: 'inherit',
        backgroundColor: 'inherit',
        outline: 'none',
        color: colors.white,
        border: '1.5px solid',
        borderColor: {
            left: colors.black,
            top: colors.black,
            right: colors.lightGrey,
            bottom: colors.lightGrey,
        },
        focus: {
            borderColor: 'inherit',
        },
        paddingLeft: '4px',
        paddingRight: '4px',
    },
    textArea: {
        background: 'inherit',
        outline: 'none',
        border: '1.5px solid',
        color: colors.white,
        borderColor: {
            left: colors.black,
            top: colors.black,
            right: colors.lightGrey,
            bottom: colors.lightGrey,
        },
        paddingLeft: '4px',
        paddingRight: '4px',
    },
    tabNavigator: {
        background: 'inherit',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
        flexDirection: 'column',
        nav: {
            height: '44px',
            color: colors.white,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-around',
            item: {
                backgroundColor: colors.lightYellow,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                flexGrow: '1',
                textAlign: 'center',
                borderRight: 'inset 1px',
                color: 'white',
                active: {
                    backgroundColor: colors.goldenrod,
                },
                content: {
                    position: 'relative',
                    flexGrow: '1',
                    width: '100%',
                },
            },
        },
    },
    slider: {
        overflow: 'hidden',
        appearance: 'none',
        height: '15px',
        backgroundColor: '#12144c',
        runnableTrack: {
            height: '15px',
            appearance: 'none',
            color: '#13bba4',
            marginTop: '-1px',
        },
        sliderThumb: {
            width: '25px',
            appearance: 'none',
            height: '30px',
            background: colors.blue,
            cursor: 'pointer',
            borderWidth: '1.5px',
            borderStyle: 'solid',
            borderColor: {
                left: 'rgb(221, 221, 221)',
                top: 'rgb(0, 0, 0)',
                right: 'rgb(0, 0, 0)',
                bottom: 'rgb(221, 221, 221)',
            },
        },
    },
    calendarContainer: {
        backgroundColor: 'inherit',
        color: 'inherit',
    },
};
export default defaultTheme;
//# sourceMappingURL=default.js.map